import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import Component from "./node-view";

export const CHECKBOX_NODE_NAME = "checkbox";

const CHECKED_SYMBOL = "☒";
const UNCHECKED_SYMBOL = "☐";

export const Checkbox = Node.create({
    name: CHECKBOX_NODE_NAME,
    group: "inline",
    inline: true,
    atom: true,
    selectable: false,
    draggable: false,

    addAttributes() {
        return {
            checked: {
                default: false,
                parseHTML: (element) => element.getAttribute("data-checked") === "true",
                renderHTML: (attributes) => ({
                    "data-checked": attributes.checked ? "true" : "false",
                }),
            },
        };
    },

    parseHTML() {
        return [
            { tag: `span[data-type="${this.name}"]` },
            {
                tag: "input[type=checkbox]",
                getAttrs: (element) => ({
                    checked: element.hasAttribute("checked") || element.checked === true,
                }),
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            mergeAttributes(HTMLAttributes, { "data-type": this.name, class: "checkbox" }),
        ];
    },

    renderText({ node }) {
        return node.attrs.checked ? CHECKED_SYMBOL : UNCHECKED_SYMBOL;
    },

    addNodeView() {
        return ReactNodeViewRenderer(Component);
    },

    addCommands() {
        return {
            insertCheckbox: ({ checked = false } = {}) => ({ commands, state }) => {
                const type = state.schema.nodes[this.name];
                if (!type) {
                    return false;
                }

                const { $from } = state.selection;
                if (!$from.parent.type.contentMatch.matchType(type)) {
                    return false;
                }

                return commands.insertContent({ type: this.name, attrs: { checked } });
            },
        };
    },
});

export default Checkbox;
